export default __webpack_public_path__ + "a25a721cbe01e42bce3d586d39b82672.png";